// Local translations
export const T = {
  en_GB: {
    columnSettings: "Column Settings",
    left: "Left",
    right: "Right",
    configureDescription: "Configure style, title, and description for the",
    column: "column",
    style: "Style",
    styleNone: "None",
    styleBorder: "Border",
    styleBox: "Box (with background)",
    styleDesc: "Choose how this column is visually styled",
    titleOptional: "Title (optional)",
    titlePlaceholder: "Enter a custom title...",
    descriptionOptional: "Description (optional)",
    descriptionPlaceholder: "Enter a custom description...",
    cancel: "Cancel",
    save: "Save",
    failedToUpdate: "Failed to update column settings",
  },
  nb_NO: {
    columnSettings: "Kolonneinnstillinger",
    left: "Venstre",
    right: "Høyre",
    configureDescription: "Konfigurer stil, tittel og beskrivelse for",
    column: "kolonne",
    style: "Stil",
    styleNone: "Ingen",
    styleBorder: "Ramme",
    styleBox: "Boks (med bakgrunn)",
    styleDesc: "Velg hvordan denne kolonnen skal vises visuelt",
    titleOptional: "Tittel (valgfritt)",
    titlePlaceholder: "Skriv inn en egendefinert tittel...",
    descriptionOptional: "Beskrivelse (valgfritt)",
    descriptionPlaceholder: "Skriv inn en egendefinert beskrivelse...",
    cancel: "Avbryt",
    save: "Lagre",
    failedToUpdate: "Kunne ikke oppdatere kolonneinnstillinger",
  },
} as const;
